module.exports = __webpack_public_path__ + "static/media/journal2.93a539d3.jpg";